import { defineComponent as _defineComponent } from 'vue'

import { getCurrentInstance, inject, onMounted, PropType } from 'vue';
import {
  commonProps,
  FabricExposition,
  injectionKey,
} from '@/core/components/data-display/Fabric/fabric.shared';
import { fabric } from 'fabric';
import { omit } from 'lodash';
import { useFabricObject } from '@/core/components/data-display/Fabric/fabric.hooks';
import { Deferred } from '@/utils/promise';
import { renderObject } from '@/core/components/data-display/Fabric/fabric';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkFabricImage',
  props: {
    ...commonProps,
    options: {
      type: Object as PropType<fabric.IImageOptions>,
      default: () => ({}),
    },
    url: {
      type: String,
      required: true,
    },
  },
  setup(__props, { expose }) {

const props = __props



const fabricInjection = inject<FabricExposition>(injectionKey);
const deferredObject = Deferred<fabric.Image | null>();
const vm = getCurrentInstance();

let image: fabric.Image;
useFabricObject(() => image, props);

const createObject = (object: fabric.Image): fabric.Image => {
  object.set('strokeWidth', 0);
  object.set({ ...omit(props.options, ['width', 'height']) });
  if (props.options.width) {
    object.scaleToWidth(props.options.width);
  }
  if (props.options.height) {
    object.scaleToHeight(props.options.height);
  }
  return object;
};

onMounted(() => {
  const canvas = fabricInjection?.getCanvas();
  (fabric.Image.fromURL as any)(props.url, (res: fabric.Image, err: boolean) => {
    if (err) {
      deferredObject.resolve(null);
      return;
    }
    deferredObject.promise.then((object) => renderObject({
      object,
      canvas,
      deferredObject,
      vm,
    }));
    image = createObject(res);

    deferredObject.resolve(image);
  });
});
expose({
  deferredObject,
});

return (_ctx: any,_cache: any) => {
  return null
}
}

})